import { render } from "./EmailFormComponent.vue?vue&type=template&id=9b4d03f0"
import script from "./EmailFormComponent.vue?vue&type=script&lang=js"
export * from "./EmailFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__